<template>
    <div class="post">
        <div class="left section">
            <img class="featured-image" v-if="image" :src="image" @click="openPost" />
        </div>

        <div class="right section">
            <div class="title">
                <p>{{title}}</p>
            </div>

            <hr class="info-divider" />

            <div class="abstract">
                <p>{{post.abstract}}</p>

            </div>

            <div class="footer">
                <a :href="post.url" target="_blank" class="link">阅读全文<small>@方略教育公众号</small></a>
                <span class="date-posted">{{datePosted}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['post'],
        computed: {
            title() {
                return this.post.title || null;
            },
            datePosted() {
                if (!this.post.publish_time) return "";

                let pts = this.$date(this.post.publish_time).valueOf() - 21600000;
                let ts = Date.now();

                if (ts - pts > 604800000)
                    return this.$date(pts).format("LL");

                return this.$date(pts).fromNow(false);
            },
            image() {
                return this.post.cover_img;
            }
        },
        methods: {
            openPost() {
                window.open(this.post.url)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .post {
        display: flex;
        margin: 3.5rem .5rem;
        // border-bottom: 1px solid gray;

        .left.section {

            width: 33%;
            min-width: 200px;

            .featured-image {
                width: 100%;
                height: 150px;
                object-fit: cover;
                cursor: pointer;
                border: .5px solid #ededed;
            }

        }

        .right.section {
            flex: 1;
            padding: .5em 1em;
            position: relative;

            p {
                margin: 0;
            }

            a.link {
                color: #01a7a9;
                display: block;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            .title {
                // font-size: 1.2rem;
                font-weight: bold;
            }

            .info-divider {
                border-top: 1px solid #dedede;
            }

            .abstract {
                color: gray;
                margin-bottom: 2rem;
            }

            .footer {

                position: absolute;
                bottom: .5em;
                left: 1em;
                right: 1em;

                display: flex;
                justify-content: space-between;

                font-size: .9rem;
                color: gray;
            }
        }

        @media (max-width: 560px) {

            flex-direction: column;

            .left.section {
                width: 100%;
            }

            .right.section {
                padding: .5em .25em;

                .footer {
                    left: .25em;
                    right: .25em;
                }
            }

        }
    }
</style>